<template>
    <div class="apiconfigure">
        <div class="title">
            <i></i>
            <span>API对接</span>
        </div>
        <div class="content" v-if="mainInfo.isOpenApi==1">
            <div class="item">
                <span class="left">机构ACCESS KEY：</span><span>{{mainInfo.accessKey}}</span>
            </div>
            <div class="item">
                <span class="left">机构ACCESS SECRET：</span><span>{{mainInfo.accessSecret}}</span>
            </div>
            <div class="item">
                <span class="left">机构DES秘钥：</span><span>{{mainInfo.encryptKey}}</span>
            </div>
            <el-form :label-position='labelPosition' label-width="200px">
                <el-form-item label="机构接收订单URL：">
                    <el-input type="text" v-model="mainInfo.pushOrderUrl" placeholder="请输入机构接收订单URL"></el-input>
                </el-form-item>
                <el-form-item label="机构接收保单URL：">
                    <el-input type="text" v-model="mainInfo.pushPolicyUrl" placeholder="请输入机构接收保单URL"></el-input>
                </el-form-item>
            </el-form>
            <el-button class="bcbtn" @click="updateAccess" type="warning">保存</el-button>
        </div>
        <div class="content" v-if="mainInfo.isOpenApi==0">
            <div class="no">
                <img src="@static/images/no.png" alt="">
                <span>该功能暂未开放，如需了解请联系商务人员</span>
            </div>
        </div>
    </div>
</template>
<script>
//当前实例组件

export default {
    data: () => ({
        labelPosition:'left',
        mainInfo:{}

    }),
    components: {

    },
    created() {
        this.queryMechanInfo()
    },
    methods: {
        //获取主体信息
        queryMechanInfo:function(){
            var  that = this;
            this.$http({
                url: '/master/mechan/queryMechanInfo',
                type: 'put',
                params:{},
            }).then(function(data) {
                that.mainInfo = data.data;
            })
        },
        updateAccess:function(){
            var  that = this;
            this.$http({
                url: '/master/mechan/updateAccess',
                type: 'post',
                params:that.mainInfo,
            }).then(function(data) {
                that.$notice.msg('保存成功',1);
            })
        }
    },
    mounted() {

    }
};
</script>
<style lang="scss">
@import "./apiCommon.scss";
</style>
